module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded,
      "caption": this.isLoaded ? 'Свернуть' : 'Загрузить',
      "expandable": true
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_vm._v("\n      История изменений\n    ")])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('div', [_c('b', [_vm._v("Названия (" + _vm._s(_vm.names.items.length) + "):")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_vm._l((_vm.names.items), function(item) {
    return [_c('div', [_vm._v("\n              " + _vm._s(_vm.getCompanyNameFull(item)) + "\n              "), _c(_vm.renderCopyButton('Копировать название', _vm.getCompanyNameFull, item), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("Кратко: " + _vm._s(_vm.getCompanyNameShort(item)) + "\n                  "), _c(_vm.renderCopyButton('Копировать краткое название', _vm.getCompanyNameShort, item), {
      tag: "v-component"
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderDateSince(item))
      }
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderUnreliableHtml(item))
      }
    })])], 1)]
  })], 2)], 1), _vm._v(" "), _c('div', [_c('b', [_vm._v("Адреса (" + _vm._s(_vm.addresses.items.length) + "):")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_vm._l((_vm.addresses.items), function(item) {
    return [_c('div', [_vm._v("\n              " + _vm._s(_vm.getAddress(item)) + "\n              "), _c(_vm.renderCopyButton('Копировать название', _vm.getAddress, item), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderDateSince(item))
      }
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderUnreliableHtml(item))
      }
    })])], 1)]
  })], 2)], 1), _vm._v(" "), _c('div', [_c('b', [_vm._v("Капитал (" + _vm._s(_vm.capitals.items.length) + "):")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_vm._l((_vm.capitals.items), function(item) {
    return [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatCapital(item))
      }
    })]
  })], 2)], 1), _vm._v(" "), _c('div', [_c('b', [_vm._v("Руководители (" + _vm._s(_vm.heads.items.length) + "):")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_vm._l((_vm.heads.items), function(item) {
    return [_c(_vm.createEmployeeComp(item), {
      tag: "v-component"
    })]
  })], 2)], 1), _vm._v(" "), _c('div', [_c('b', [_vm._v("Участники (" + _vm._s(_vm.holders.items.length) + "):")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_vm._l((_vm.holders.items), function(item) {
    return [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHolderNamespace(item, 'ogrn')),
        expression: "isHolderNamespace(item,'ogrn')"
      }]
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.refObject))
      }
    }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать название', _vm.getNameFull, item), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("ИНН "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnHtml(item.refObject.inn))
      }
    }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать инн', _vm.getInn, item), {
      tag: "v-component"
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatShares(item.shares))
      }
    })])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHolderNamespace(item, 'HUMAN')),
        expression: "isHolderNamespace(item,'HUMAN')"
      }]
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.refObject))
      }
    }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать ФИО', _vm.getNameFull, item), {
      tag: "v-component"
    }), _vm._v(" "), _c(_vm.renderContactButton('Открыть контакт физического лица', _vm.openContact, item), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("ИНН "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnflHtml(item.refObject.inn))
      }
    }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать инн', _vm.getInn, item), {
      tag: "v-component"
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatShares(item.shares))
      }
    })])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHolderNamespace(item, 'FOREIGN')),
        expression: "isHolderNamespace(item,'FOREIGN')"
      }]
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.refObject))
      }
    }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать название', _vm.getNameFull, item), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatShares(item.shares))
      }
    })])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHolderNamespace(item, 'MUNICIPAL')),
        expression: "isHolderNamespace(item,'MUNICIPAL')"
      }]
    }, [_c('span', [_vm._v(_vm._s(_vm.getMunicipalNameFull(item)) + "\n              ")]), _vm._v(" "), _c(_vm.renderCopyButton('Копировать название', _vm.getMunicipalNameFull, item), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatShares(item.shares))
      }
    })])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHolderNamespace(item, 'PIF')),
        expression: "isHolderNamespace(item,'PIF')"
      }]
    }, [_c('span', [_vm._v(_vm._s(_vm.getPifNameFull(item)))]), _vm._v(" "), _c(_vm.renderCopyButton('Копировать название', _vm.getPifNameFull, item), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatShares(item.shares))
      }
    })])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHolderNamespace(item, 'OTHER')),
        expression: "isHolderNamespace(item,'OTHER')"
      }]
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.refObject))
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatWarningHtml('Запись об учредителе не поддерживается.'))
      }
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatShares(item.shares))
      }
    })])], 1), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderUnreliableHtml(item))
      }
    })]
  })], 2)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a07ac32e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/HistoryPanel.vue
// module id = 1077
// module chunks = 1